<div [dir]="biService.getDir() ? 'rtl': 'ltr'" [ngClass]="{'menu-open':!closed, 'menu-open-right': isRight}"
  class="sidebar-container">
  <div [style.max-width]="collapsed ? '50px': null" class="custom-toolbar text-nowrap d-flex">
    <div *ngIf="!mobile" [style.background-color]="collapsed ? '#D7481F': null" class="pb-0">
      <kendo-button fillMode="none" [svgIcon]="menuSVG"  class="border-0 right-collapsed" [ngStyle]="isRight ? 
    {'padding': closed ? '13px 13px 10px 13px' : '15px 12px 10px 13px'} : 
    {'padding': closed ? '13px 13px 10px 13px' : '15px 12.5px 15px 13px'}"
        [ngClass]="collapsed ? 'text-white' : 'text-dark'"
        (click)="changeBackGround(); closed= false; CheckToggleDrawer()"></kendo-button>
    </div>

    <div *ngIf="mobile && closed" class="mobile-menu-btn">
      <kendo-button fillMode="none" [svgIcon]="menuSVG" class="border-0 text-dark collapse-btn"
        (click)="closed= false; selected = ''"></kendo-button>
    </div>

    <div *ngIf="collapsed && mobile && !closed" [style.background-color]="collapsed ? '#D7481F': null"
      class="pb-0 d-flex justify-content-between">
      <kendo-button fillMode="none" [svgIcon]="closeSVG"  class="border-0"
        [ngStyle]="{'padding': isRight ? '15px 16.5px 5px 9px' :'15px 12.5px 5px 13.5px'}"
        [ngClass]="collapsed ? 'text-white' : 'text-dark'" (click)="closeMenu()"></kendo-button>
    </div>

    <div *ngIf="!collapsed && !closed" class="m-1">
      <img src="assets/images/buzz-logo-menu.png" class="buzz-logo-menu" alt="">
    </div>

    <div *ngIf="!collapsed && mobile && !closed" [style.background-color]="collapsed ? '#D7481F': null"
      class="pb-0 d-flex justify-content-between">
      <kendo-button fillMode="none" [svgIcon]="closeSVG"  class="border-0 collapse-btn"
        [ngClass]="collapsed ? 'text-white' : 'text-dark'" (click)="closeMenu()"></kendo-button>
    </div>
  </div>

  <div class="custom-toolbar" [style.display]="(mobile && closed) ? 'none': 'block'">
    <div *ngIf="!collapsed">
      <ng-container *ngTemplateOutlet="sideBarSearch"></ng-container>
    </div>

    <div *ngIf="(searchValue.length > 0 && !collapsed)">
      <ng-container [ngTemplateOutlet]="sidebarSearchResults"
        [ngTemplateOutletContext]="{'contentView': 'mainMenu'}"></ng-container>
    </div>
  </div>

  <kendo-drawer-container class="kendo-drawer-container" [dir]="biService.getDir() ? 'rtl': 'ltr'" *ngIf="!closed">
    <kendo-drawer #drawer [items]="!(searchValue.length > 0 && !collapsed) ? items : []" mode="push" [mini]="true"
      [expanded]="true" (select)="onSelect($event)" class="drawer">
      <ng-template kendoDrawerItemTemplate let-item>
        <img [matTooltip]="collapsed ? (item.text | translate): null" matTooltipPosition="right" *ngIf="item.children"
          [src]="item.icon" />
        <a [matTooltip]="collapsed ? (item.text | translate): null" matTooltipPosition="right" *ngIf="!item.children"
          (click)="navigateToScreen(item.path)" class="text-decoration-none a-link"><img [src]="item.icon" /></a>
        <div *ngIf="!collapsed">
          <div *ngIf="item.children">{{ item.text | translate}}</div>
          <div *ngIf="!item.children"><a (click)="navigateToScreen(item.path)" class="text-decoration-none a-link">{{
              item.text | translate}}</a></div>
        </div>
      </ng-template>
    </kendo-drawer>

    <kendo-drawer-content class="side-content">
      <ng-container *ngIf="collapsed">
        <ng-container *ngIf="showSearchInSideContent">
          <ng-container *ngTemplateOutlet="sideBarSearch"></ng-container>
        </ng-container>

        <ng-container *ngIf="searchValue.length > 0">
          <ng-container [ngTemplateOutlet]="sidebarSearchResults"
            [ngTemplateOutletContext]="{'contentView': 'subMenu'}"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="searchValue.length === 0">
        <SideBar-content #SideBarContent [isRight]="biService.getDir()" (navigateToScreen)="navigateToScreen($event)"
          (backToNav)="CheckToggleDrawer(); changeBackGround(); backToNav()" [collapsed]="collapsed" [items]="items"
          [selectedItem]="selected" [selectedMenuItem]="selectedMenuItem"></SideBar-content>
      </ng-container>
    </kendo-drawer-content>
  </kendo-drawer-container>
</div>

<ng-template #sideBarSearch>
  <div class="d-flex">
    <bi-search #BiSearch (searchChanges)="getSearchChanges($event)" [searchDataList]="searchDataList"></bi-search>
  </div>
</ng-template>

<ng-template #sidebarSearchResults let-contentView='contentView'>
  <sidebar-search-results [searchResults]="searchResults" [searchValue]="searchValue" [contentView]="contentView"
    (routeNavigated)="getRouteToNavigate($event)"></sidebar-search-results>
</ng-template>